import axios from "axios";
import { apiUrl, configWithUserId } from "./headerConfigs";

const submitBestTimeBid = async ({ bidStartTime, rideId, driverId }) => {
  return axios.post(
    `${apiUrl}/Rides/SubmitBid`,
    {
      driver_id: driverId,
      ride_id: rideId,
      bid_start_time: bidStartTime,
    },
    configWithUserId,
  );
};

const reassignRide = ({ rideId, driverId }) =>
  axios.post(
    `${apiUrl}/Rides/ReassignRide`,
    { ride_id: rideId, driver_id: driverId },
    configWithUserId,
  );

export { submitBestTimeBid, reassignRide };
